// extracted by mini-css-extract-plugin
module.exports = {"root":"SaveButton__root--1P-x6","saved":"SaveButton__saved--2j4Ag","text":"SaveButton__text--3u98t","icon":"SaveButton__icon--1L_J2","bounce":"SaveButton__bounce--gRVAf"};